"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterHandler = exports.GithubHandler = exports.TwitchHandler = exports.DiscordHandler = exports.RedditHandler = exports.GoogleHandler = exports.request = void 0;
var logger_1 = require("./logger");
var types_1 = require("./types");
var utils_1 = require("./utils");
var config_1 = __importDefault(require("./config"));
var errors_1 = require("./errors");
var request = function (url, headers) {
    if (headers === void 0) { headers = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, data, logger;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, { headers: headers })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    logger = (0, logger_1.getLogger)('request');
                    if (response.status < 400) {
                        return [2 /*return*/, data];
                    }
                    else {
                        logger.error('error_during_request', { err: data });
                        throw new errors_1.ArcanaAuthException("Error during getting user info");
                    }
                    return [2 /*return*/];
            }
        });
    });
};
exports.request = request;
var GoogleHandler = /** @class */ (function () {
    function GoogleHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.google;
        this.oauthUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
        this.responseType = 'token id_token';
        this.scope = 'profile email openid';
        this.prompt = 'consent select_account';
        this.userInfoUrl = 'https://www.googleapis.com/userinfo/v2/me';
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (params.access_token && !params.id_token) {
                    return [2 /*return*/, __assign(__assign({}, params), { id_token: params.access_token })];
                }
                else {
                    return [2 /*return*/, __assign({}, params)];
                }
                return [2 /*return*/];
            });
        }); };
        return;
    }
    GoogleHandler.prototype.getAuthUrl = function (_a) {
        var clientID = _a.clientID, redirectUri = _a.redirectUri, state = _a.state, nonce = _a.nonce;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = new URL(this.oauthUrl);
                url.searchParams.append('client_id', clientID);
                url.searchParams.append('redirect_uri', redirectUri);
                url.searchParams.append('state', state);
                url.searchParams.append('scope', this.scope);
                url.searchParams.append('response_type', this.responseType);
                url.searchParams.append('prompt', this.prompt);
                url.searchParams.append('nonce', nonce ? nonce : (0, utils_1.generateID)());
                return [2 /*return*/, url.toString()];
            });
        });
    };
    GoogleHandler.prototype.getUserInfo = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, exports.request)(this.userInfoUrl, {
                                Authorization: "Bearer " + accessToken,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                id: data.email,
                                email: data.email,
                                name: data.name,
                                picture: data.picture,
                            }];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GoogleHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return GoogleHandler;
}());
exports.GoogleHandler = GoogleHandler;
var RedditHandler = /** @class */ (function () {
    function RedditHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.reddit;
        this.userInfoUrl = 'https://oauth.reddit.com/api/v1/me';
        this.scope = 'identity';
        this.responseType = 'token';
        this.oauthUrl = 'https://www.reddit.com/api/v1/authorize';
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (params.access_token && !params.id_token) {
                    return [2 /*return*/, __assign(__assign({}, params), { id_token: params.access_token })];
                }
                else {
                    return [2 /*return*/, __assign({}, params)];
                }
                return [2 /*return*/];
            });
        }); };
        return;
    }
    RedditHandler.prototype.getAuthUrl = function (_a) {
        var clientID = _a.clientID, redirectUri = _a.redirectUri, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = new URL(this.oauthUrl);
                url.searchParams.append('client_id', clientID);
                url.searchParams.append('redirect_uri', redirectUri);
                url.searchParams.append('state', state);
                url.searchParams.append('scope', this.scope);
                url.searchParams.append('response_type', this.responseType);
                return [2 /*return*/, url.toString()];
            });
        });
    };
    RedditHandler.prototype.getUserInfo = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, exports.request)(this.userInfoUrl, {
                                Authorization: "Bearer " + accessToken,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, { id: data.name, name: data.name, picture: data.icon_img }];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RedditHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return RedditHandler;
}());
exports.RedditHandler = RedditHandler;
var DiscordHandler = /** @class */ (function () {
    function DiscordHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.discord;
        this.oauthUrl = 'https://discord.com/api/oauth2/authorize';
        this.responseType = 'token';
        this.scope = 'identify email';
        this.userInfoUrl = 'https://discordapp.com/api/users/@me';
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (params.access_token && !params.id_token) {
                    return [2 /*return*/, __assign(__assign({}, params), { id_token: params.access_token })];
                }
                else {
                    return [2 /*return*/, __assign({}, params)];
                }
                return [2 /*return*/];
            });
        }); };
        return;
    }
    DiscordHandler.prototype.getAuthUrl = function (_a) {
        var clientID = _a.clientID, redirectUri = _a.redirectUri, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = new URL(this.oauthUrl);
                url.searchParams.append('client_id', clientID);
                url.searchParams.append('redirect_uri', redirectUri);
                url.searchParams.append('state', state);
                url.searchParams.append('scope', this.scope);
                url.searchParams.append('response_type', this.responseType);
                return [2 /*return*/, url.toString()];
            });
        });
    };
    DiscordHandler.prototype.getUserInfo = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, exports.request)(this.userInfoUrl, {
                                Authorization: "Bearer " + accessToken,
                            })];
                    case 1:
                        data = _a.sent();
                        if (data.verified && data.email) {
                            return [2 /*return*/, {
                                    id: data.email,
                                    name: data.username,
                                    picture: data.avatar,
                                }];
                        }
                        return [2 /*return*/, {
                                id: data.id,
                                name: data.username,
                                picture: data.avatar,
                            }];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DiscordHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return DiscordHandler;
}());
exports.DiscordHandler = DiscordHandler;
var TwitchHandler = /** @class */ (function () {
    function TwitchHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.twitch;
        this.userInfoUrl = 'https://api.twitch.tv/helix/users';
        this.oauthUrl = 'https://id.twitch.tv/oauth2/authorize';
        this.scope = 'openid user:read:email';
        this.responseType = 'token';
        this.claims = JSON.stringify({
            id_token: { email: null, email_verified: null },
            userinfo: { email: null, email_verified: null },
        });
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (params.access_token && !params.id_token) {
                    return [2 /*return*/, __assign(__assign({}, params), { id_token: params.access_token })];
                }
                else {
                    return [2 /*return*/, __assign({}, params)];
                }
                return [2 /*return*/];
            });
        }); };
        return;
    }
    TwitchHandler.prototype.getAuthUrl = function (_a) {
        var clientID = _a.clientID, redirectUri = _a.redirectUri, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                this.clientId = clientID;
                url = new URL(this.oauthUrl);
                url.searchParams.append('client_id', clientID);
                url.searchParams.append('redirect_uri', redirectUri);
                url.searchParams.append('state', state);
                url.searchParams.append('scope', this.scope);
                url.searchParams.append('response_type', this.responseType);
                url.searchParams.append('claims', this.claims);
                url.searchParams.append('force_verify', 'true');
                return [2 /*return*/, url.toString()];
            });
        });
    };
    TwitchHandler.prototype.getUserInfo = function (accessToken) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_4;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, exports.request)(this.userInfoUrl, {
                                Authorization: "Bearer " + accessToken,
                                'Client-ID': this.clientId,
                            })];
                    case 1:
                        data = _f.sent();
                        return [2 /*return*/, {
                                id: ((_a = data.data[0]) === null || _a === void 0 ? void 0 : _a.email) ? (_b = data.data[0]) === null || _b === void 0 ? void 0 : _b.email : (_c = data.data[0]) === null || _c === void 0 ? void 0 : _c.id,
                                name: (_d = data.data[0]) === null || _d === void 0 ? void 0 : _d.display_name,
                                picture: (_e = data.data[0]) === null || _e === void 0 ? void 0 : _e.profile_image_url,
                            }];
                    case 2:
                        e_4 = _f.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TwitchHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return TwitchHandler;
}());
exports.TwitchHandler = TwitchHandler;
var GithubHandler = /** @class */ (function () {
    function GithubHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.github;
        this.url = 'https://api.github.com/user';
        this.oauthUrl = 'https://github.com/login/oauth/authorize';
        this.sigUrl = config_1.default.signatureUrl + "/github";
        this.responseType = 'token id_token';
        this.scope = 'read:user user:email';
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!params.code) {
                            throw new errors_1.ArcanaAuthException('Expected `code` from github hash params');
                        }
                        return [4 /*yield*/, this.getTokenFromCode(this.appID, params.code)];
                    case 1:
                        accessToken = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, params), { access_token: accessToken, id_token: accessToken })];
                }
            });
        }); };
        return;
    }
    GithubHandler.prototype.getAuthUrl = function (_a) {
        var clientID = _a.clientID, redirectUri = _a.redirectUri, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = new URL(this.oauthUrl);
                url.searchParams.append('client_id', clientID);
                url.searchParams.append('redirect_uri', redirectUri);
                url.searchParams.append('state', state);
                url.searchParams.append('scope', this.scope);
                url.searchParams.append('response_type', this.responseType);
                return [2 /*return*/, url.toString()];
            });
        });
    };
    GithubHandler.prototype.getTokenFromCode = function (appID, code) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, exports.request)(this.sigUrl + "/" + appID + "/" + code)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.accessToken];
                }
            });
        });
    };
    GithubHandler.prototype.getUserInfo = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, exports.request)(this.url, {
                                Authorization: "token " + accessToken,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                id: data.email ? data.email : String(data.id),
                                email: data.email,
                                name: data.name,
                                picture: data.avatar_url,
                            }];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GithubHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return GithubHandler;
}());
exports.GithubHandler = GithubHandler;
var TwitterHandler = /** @class */ (function () {
    function TwitterHandler(appID) {
        var _this = this;
        this.appID = appID;
        this.loginType = types_1.LoginType.twitter;
        this.sigUrl = config_1.default.signatureUrl + "/twitter";
        this.oauthUrl = 'https://api.twitter.com/oauth/authorize?oauth_token=';
        this.handleRedirectParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var oauthTokenVerified;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(params.oauth_token && params.oauth_verifier)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAccessToken({
                                oauth_token: params.oauth_token,
                                oauth_verifier: params.oauth_verifier,
                            })];
                    case 1:
                        oauthTokenVerified = _a.sent();
                        this.oauthToken = oauthTokenVerified.oauth_token;
                        this.oauthTokenSecret = oauthTokenVerified.oauth_token_secret;
                        params.id_token = [
                            this.oauthToken,
                            this.oauthTokenSecret,
                            this.appID,
                        ].join(':');
                        return [2 /*return*/, __assign(__assign(__assign({}, params), { access_token: this.oauthToken }), oauthTokenVerified)];
                    case 2: return [2 /*return*/, __assign({}, params)];
                }
            });
        }); };
    }
    TwitterHandler.prototype.getRequestToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(this.sigUrl + "/" + this.appID + "/requestToken");
                        return [4 /*yield*/, (0, exports.request)(url.toString())];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    TwitterHandler.prototype.getAuthUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequestToken()];
                    case 1:
                        params = _a.sent();
                        this.oauthToken = params.oauth_token;
                        this.oauthTokenSecret = params.oauth_token;
                        if (!this.oauthToken) {
                            throw new errors_1.ArcanaAuthException('Error did not have token when expected!');
                        }
                        return [2 /*return*/, this.oauthUrl + this.oauthToken];
                }
            });
        });
    };
    TwitterHandler.prototype.getAccessToken = function (_a) {
        var oauth_token = _a.oauth_token, oauth_verifier = _a.oauth_verifier;
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!oauth_token || !oauth_verifier) {
                            throw new errors_1.ArcanaAuthException("Missing token or verifier");
                        }
                        url = new URL(this.sigUrl + "/accessToken");
                        url.searchParams.append('oauth_token', oauth_token);
                        url.searchParams.append('oauth_verifier', oauth_verifier);
                        return [4 /*yield*/, (0, exports.request)(url.toString())];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    TwitterHandler.prototype.getUserInfo = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = new URL(this.sigUrl + "/" + this.appID + "/user");
                        url.searchParams.append('oauth_token', accessToken);
                        url.searchParams.append('oauth_token_secret', this.oauthTokenSecret);
                        return [4 /*yield*/, (0, exports.request)(url.toString())];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                id: data.email ? data.email : data.id_str,
                                email: data.email,
                                name: data.name,
                                picture: data.profile_image_url_https,
                            }];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TwitterHandler.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, err_1, logger;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = new URL(this.sigUrl + "/" + this.appID + "/invalidateToken");
                        url.searchParams.append('oauth_token', this.oauthToken);
                        url.searchParams.append('oauth_token_secret', this.oauthTokenSecret);
                        return [4 /*yield*/, (0, exports.request)(url.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        logger = (0, logger_1.getLogger)('twitter');
                        logger.error('error_cleanup_twitter', { err: err_1 });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return TwitterHandler;
}());
exports.TwitterHandler = TwitterHandler;
